import { render, staticRenderFns } from "./NoticesView.vue?vue&type=template&id=55fc9160&"
import script from "./NoticesView.vue?vue&type=script&lang=js&"
export * from "./NoticesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports